import React from 'react';
import { SectionLabel } from './SectionLabel';
export function SelectedVoices() {
  return <section className="py-32 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto border-t border-ink/10" data-id="element-64" data-mp="2pwit5e4m4epk">
      <SectionLabel number="02" title="Selected Voices" data-id="element-65" data-mp="33nxdboa9aly7" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 mt-16" data-id="element-66" data-mp="33pi89f0hg6wl">
        <div className="flex flex-col" data-id="element-67" data-mp="2youjkzzq825j">
          <p className="font-serif italic text-2xl md:text-3xl leading-relaxed text-ink mb-8 flex-grow" data-id="element-68" data-mp="2ayqgctqga4f2">
            "Vera opened my eyes to what was still possible in my 50s. They
            steered me around injuries, and I show up to skiing and golf the way
            I used to. It changed how I move through the rest of my life."
          </p>
          <div className="font-mono text-xs uppercase tracking-widest text-ink/60" data-id="element-69" data-mp="2fx1qz6okkiyc">
            Jaret W.
          </div>
        </div>

        <div className="flex flex-col" data-id="element-70" data-mp="8i6sx136uht">
          <p className="font-serif italic text-2xl md:text-3xl leading-relaxed text-ink mb-8 flex-grow" data-id="element-71" data-mp="3rdrpe3mr46he">
            "Vera built a system around me the way I would build one for my own
            business. There is more structure, more discipline, and the kind of
            energy that lets me show up for my work and my kids without running
            on empty."
          </p>
          <div className="font-mono text-xs uppercase tracking-widest text-ink/60" data-id="element-72" data-mp="1un8f58wpqlly">
            Jeremy W.
          </div>
        </div>

        <div className="flex flex-col" data-id="element-73" data-mp="x12oty12i15o">
          <p className="font-serif italic text-2xl md:text-3xl leading-relaxed text-ink mb-8 flex-grow" data-id="element-74" data-mp="wxx1an8377c2">
            "Different people need different experiences. Vera will find your
            sweet spot. Some need cuddled. Some need kicked. I needed both and
            they never missed."
          </p>
          <div className="font-mono text-xs uppercase tracking-widest text-ink/60" data-id="element-75" data-mp="e99v21e6cbww">
            Joe C.
          </div>
        </div>
      </div>
    </section>;
}